/** Map CMS category slugs to i18n message keys (legacy aliases kept for routes). */
export const NAV_SLUG_I18N_KEYS = {
  'hvac-refrigeration': ['hvac-refrigeration', 'hvac'],
  battery: ['battery', 'batteries'],
  semiconductor: ['semiconductor', 'semiconductors'],
  'medical-devices': ['medical-devices', 'medical'],
  'defense-aerospace': ['defense-aerospace', 'aerospace'],
  'new-materials': ['new-materials', 'advanced-materials'],
  'wire-connector': ['wire-connector', 'wires-connectors'],
  other: ['other', 'others']
}

export function navLabelKeys(slug) {
  if (!slug) return []
  const aliasKeys = NAV_SLUG_I18N_KEYS[slug]
  return aliasKeys ? [...aliasKeys] : [slug]
}

export function resolveI18nNavLabel(messages, group, slug, fallback) {
  if (!group || !slug) return fallback || ''
  const keys = navLabelKeys(slug)
  for (let i = 0; i < keys.length; i++) {
    const g = messages[group]
    const label = g && g[keys[i]]
    if (label) return label
  }
  return fallback || slug
}

/** Prefer CMS name when item comes from the database; otherwise use i18n/static labels. */
export function resolveNavItemName(messages, group, item) {
  if (!item) return ''
  const cmsName = String(item.categoryName || item.name || item.itemName || '').trim()
  const slug = item.slug || item.categorySlug || item.itemSlug || ''
  if (cmsName && (item.id != null || item.categoryName || item.hash != null || item.itemType != null)) {
    return cmsName
  }
  return resolveI18nNavLabel(messages, group, slug, cmsName)
}
